import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";

import styled from "styled-components";
import axios from "axios";
import AmbassadorsList from "../tools/AmbassadorsList";
import { Button } from "../../ui-kit/styled-templates";
import moment from "moment";
import { Sidebar } from "arui-feather/sidebar";
import AdminSearchAmbassadorTool from "../tools/AdminSearchAmbassadorTool";
import Tabs, { TabItem } from "../../ui/Tabs";
import UserInvitedFriendsTool from "../../referral/tools/UserInvitedFriendsTool";
import UserReferralsTool from "../../referral/tools/UserReferralsTool";
import AdminPostsPanel from "../../posts/panels/AdminPostsPanel";
import toast from "react-hot-toast";
import { Control } from "../../ui-kit/control";
import { resolveFileUrl } from "constants/config";
import { useStorageListener } from "../../../hooks/useStorage";

import Select from "react-select";
import { getFriendlyRegionsOptions } from "../../rmap/RussiaMap";
import AmbStatsTool from "../tools/AmbStatsTool";
import AmbStatsPanel from "./AmbStatsPanel";
import defaultAvatarImg from "../../../assets/images/cheb.jpg";

const AMB_TYPES = [
    {
        label: "Почетный",
        value: true
    },
    {
        label: "Обычный",
        value: false
    }
];

export const AMB_TYPES_NEW = [
    {
        label: "Амбассадор",
        value: 'Амбассадор'
    },
    {
        label: "Почетный Амбассадор",
        value: 'Почетный Амбассадор'
    },
    {
        label: "МедиаАмбассадор",
        value: 'МедиаАмбассадор'
    },
    {
        label: "Проактивный Амбассадор",
        value: 'Проактивный Амбассадор'
    },
    {
        label: "Проактивный МедиаАмбассадор",
        value: 'Проактивный МедиаАмбассадор'
    }
];

function getAllUnisOptions(universities = {}) {
    let allUnis = Object.keys(universities).map(x => universities[x]);
    return allUnis.map(x => {
        const shortName = x?.details?.shortName || '';
        const fullName = x?.details?.name || '';
        return {
            value: x.id,
            label: shortName ? `${shortName} (${fullName})` : fullName,
            fullName: fullName // сохраняем полное название отдельно
        };
    });
}

export default function AdminAmbassadorsPanel(props) {

    const [addVisible, setAddVisible] = useState(false);
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const universities = useStorageListener(`universities`, {});

    const [selectedUserId, setSelectedUserId] = useState(undefined);

    // Массовые операции
    const [viewMode, setViewMode] = useState('cards'); // 'cards' | 'table'
    const [selectedAmbassadors, setSelectedAmbassadors] = useState([]);
    const [bulkExtendModalVisible, setBulkExtendModalVisible] = useState(false);
    const [bulkRevokeModalVisible, setBulkRevokeModalVisible] = useState(false);
    const [bulkAddModalVisible, setBulkAddModalVisible] = useState(false);
    const [bulkChangeTypeModalVisible, setBulkChangeTypeModalVisible] = useState(false);
    const [newExpirationDate, setNewExpirationDate] = useState('');
    const [newAmbassadorType, setNewAmbassadorType] = useState('Амбассадор');
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        setLoading(true);
        axios.get("/ambassadors/all").then(d => d.data).then(arr => {
            setUsers(arr);
            setLoading(false);
        });
    }, []);

    let selectedUser = (selectedUserId == undefined) ? undefined : users.find(x => (x.id == selectedUserId));

    console.log("--->> > selectedUserId = ", selectedUserId);
    console.log("--->> > selectedUser = ", selectedUser);

    let allUnis = Object.keys(universities).map(x => universities[x]);
    console.log("allUnis = ", allUnis);

    const regionsOptions = getFriendlyRegionsOptions();

    let sortedUsers = users.sort((a, b) => {
        let scoreA = (+a.timestamp + (a.isVip == true ? 10000000000 : 0));
        let scoreB = (+b.timestamp + (b.isVip == true ? 10000000000 : 0));
        return -(scoreA - scoreB);
    });

    // Фильтрация по поисковому запросу
    const filteredUsers = sortedUsers.filter(user => {
        if (!searchQuery) return true;

        const query = searchQuery.toLowerCase();
        const name = (user.name || `${user.firstName || ''} ${user.lastName || ''}`).toLowerCase();
        const email = (user.email || '').toLowerCase();
        const universityName = (user.universityName || '').toLowerCase();
        const ambassadorType = (user.ambassadorType || '').toLowerCase();

        return name.includes(query) ||
               email.includes(query) ||
               universityName.includes(query) ||
               ambassadorType.includes(query);
    });

    // Обработчики массовых операций
    const handleSelectAll = () => {
        if (selectedAmbassadors.length === filteredUsers.length) {
            setSelectedAmbassadors([]);
        } else {
            setSelectedAmbassadors(filteredUsers.map(u => u.id));
        }
    };

    const handleToggleAmbassador = (id) => {
        setSelectedAmbassadors(prev => {
            if (prev.includes(id)) {
                return prev.filter(x => x !== id);
            } else {
                return [...prev, id];
            }
        });
    };

    const handleBulkRevoke = async () => {
        if (selectedAmbassadors.length === 0) return;

        setBulkRevokeModalVisible(false);
        setLoading(true);

        try {
            for (let ambassadorId of selectedAmbassadors) {
                await axios.put(`/ambassadors`, {
                    id: ambassadorId,
                    isAmbassador: false
                });
            }

            let arr = (await axios.get("/ambassadors/all")).data;
            setUsers(arr);
            setSelectedAmbassadors([]);
            toast.success(`Статус амбассадора отозван у ${selectedAmbassadors.length} пользователей`);
        } catch (exc) {
            toast.error('Ошибка при отзыве статуса');
        }

        setLoading(false);
    };

    const handleBulkExtend = async () => {
        if (selectedAmbassadors.length === 0) return;
        if (!newExpirationDate) {
            toast.error('Укажите новый срок действия');
            return;
        }

        setBulkExtendModalVisible(false);
        setLoading(true);

        try {
            for (let ambassadorId of selectedAmbassadors) {
                await axios.put(`/ambassadors`, {
                    id: ambassadorId,
                    ambassadorExpirationTimestamp: newExpirationDate
                });
            }

            let arr = (await axios.get("/ambassadors/all")).data;
            setUsers(arr);
            setSelectedAmbassadors([]);
            setNewExpirationDate('');
            toast.success(`Срок действия статуса продлен для ${selectedAmbassadors.length} амбассадоров`);
        } catch (exc) {
            toast.error('Ошибка при продлении статуса');
        }

        setLoading(false);
    };

    const handleBulkAdd = async (emailsText, ambassadorType, expirationDate) => {
        const emails = emailsText
            .split(/[\n,;]/)
            .map(e => e.trim().toLowerCase())
            .filter(e => e.length > 0 && e.includes('@'));

        if (emails.length === 0) {
            toast.error('Введите хотя бы один email');
            return [];
        }

        setLoading(true);

        try {
            const foundUsers = [];
            const notFound = [];

            for (let email of emails) {
                try {
                    let response = await axios.get(`/ambassadors/find-by-email`, {
                        params: { email },
                        timeout: 10000 // 10 секунд таймаут на запрос
                    });

                    let user = response.data;

                    if (user && user.id) {
                        foundUsers.push(user);
                    } else {
                        notFound.push(email);
                    }
                } catch (exc) {
                    // Пользователь не найден или ошибка запроса
                    notFound.push(email);
                }
            }

            if (notFound.length > 0) {
                toast.error(`Не найдены пользователи (${notFound.length}): ${notFound.slice(0, 5).join(', ')}${notFound.length > 5 ? '...' : ''}`);
            }

            if (foundUsers.length === 0) {
                toast.error('Не найдено ни одного зарегистрированного пользователя');
                setLoading(false);
                return [];
            }

            setLoading(false);
            return foundUsers;
        } catch (exc) {
            toast.error('Ошибка при поиске пользователей');
            setLoading(false);
            return [];
        }
    };

    const handleAssignAmbassadors = async (userIds, ambassadorType, expirationDate) => {
        setLoading(true);

        try {
            let isVip = (ambassadorType === "Почетный Амбассадор");

            for (let userId of userIds) {
                await axios.put(`/ambassadors`, {
                    id: userId,
                    isAmbassador: true,
                    ambassadorType: ambassadorType,
                    isVip: isVip,
                    ambassadorExpirationTimestamp: expirationDate
                });
            }

            let arr = (await axios.get("/ambassadors/all")).data;
            setUsers(arr);
            setBulkAddModalVisible(false);
            toast.success(`Статус амбассадора назначен ${userIds.length} пользователям`);
        } catch (exc) {
            toast.error('Ошибка при назначении статуса');
        }

        setLoading(false);
    };

    const handleBulkChangeType = async () => {
        if (!newAmbassadorType) {
            toast.error('Выберите тип амбассадора');
            return;
        }

        setBulkChangeTypeModalVisible(false);
        setLoading(true);

        try {
            let isVip = (newAmbassadorType === "Почетный Амбассадор");

            for (let ambassadorId of selectedAmbassadors) {
                await axios.put(`/ambassadors`, {
                    id: ambassadorId,
                    ambassadorType: newAmbassadorType,
                    isVip: isVip
                });
            }

            let arr = (await axios.get("/ambassadors/all")).data;
            setUsers(arr);
            setSelectedAmbassadors([]);
            toast.success(`Тип амбассадора изменен у ${selectedAmbassadors.length} пользователей`);
        } catch (exc) {
            toast.error('Ошибка при изменении типа');
        }

        setLoading(false);
    };

    return (
        <Wrapper>

            <Tabs
                tabs={[
                    {
                        label: "Амбассадоры",
                        content: (
                            <div>
                                <TopPlaceholder>
                                    <ViewToggleWrapper>
                                        <ViewToggleButton
                                            active={viewMode === 'cards'}
                                            onClick={() => {
                                                setViewMode('cards');
                                                setSelectedAmbassadors([]);
                                            }}
                                        >
                                            Карточки
                                        </ViewToggleButton>
                                        <ViewToggleButton
                                            active={viewMode === 'table'}
                                            onClick={() => setViewMode('table')}
                                        >
                                            Таблица
                                        </ViewToggleButton>
                                    </ViewToggleWrapper>

                                    <ButtonGroup>
                                        <Button onClick={() => {
                                            setAddVisible(true);
                                        }}>
                                            Добавить амбассадора
                                        </Button>

                                        <Button onClick={() => {
                                            setBulkAddModalVisible(true);
                                        }}>
                                            Массовое назначение
                                        </Button>
                                    </ButtonGroup>
                                </TopPlaceholder>

                                <SearchSection>
                                    <SearchInput
                                        type="text"
                                        placeholder="Поиск по имени, email, ООВО или типу амбассадора..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                    {searchQuery && (
                                        <ClearButton onClick={() => setSearchQuery('')}>
                                            ✕
                                        </ClearButton>
                                    )}
                                    <SearchResults>
                                        Найдено: {filteredUsers.length} из {sortedUsers.length}
                                    </SearchResults>
                                </SearchSection>

                                {viewMode === 'cards' ? (
                                    <ListPlaceholder>
                                        <AmbassadorsList
                                            users={filteredUsers}
                                            onSelect={dd => {
                                                setSelectedUserId(dd?.id);
                                            }}
                                        />
                                    </ListPlaceholder>
                                ) : (
                                    <>
                                        {selectedAmbassadors.length > 0 && (
                                            <BulkActionsPanel>
                                                <BulkActionsText>
                                                    Выбрано: {selectedAmbassadors.length}
                                                </BulkActionsText>
                                                <Button onClick={() => setBulkExtendModalVisible(true)}>
                                                    Продлить срок ({selectedAmbassadors.length})
                                                </Button>
                                                <Button onClick={() => setBulkChangeTypeModalVisible(true)}>
                                                    Изменить тип ({selectedAmbassadors.length})
                                                </Button>
                                                <Button onClick={() => setBulkRevokeModalVisible(true)}>
                                                    Прекратить статус ({selectedAmbassadors.length})
                                                </Button>
                                            </BulkActionsPanel>
                                        )}

                                        <TableWrapper>
                                            <Table>
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '40px' }}>
                                                            <CheckboxWithTooltip
                                                                title={selectedAmbassadors.length === filteredUsers.length && filteredUsers.length > 0
                                                                    ? "Снять выделение всех"
                                                                    : "Выбрать всех"}
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedAmbassadors.length === filteredUsers.length && filteredUsers.length > 0}
                                                                    onChange={handleSelectAll}
                                                                />
                                                            </CheckboxWithTooltip>
                                                        </th>
                                                        <th>Фото</th>
                                                        <th>ФИО</th>
                                                        <th>Email</th>
                                                        <th>Тип</th>
                                                        <th>ООВО</th>
                                                        <th>Срок действия</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredUsers.map((user, i) => {
                                                        let isExpired = (user.ambassadorExpirationTimestamp != undefined && +user.ambassadorExpirationTimestamp < +new Date());

                                                        return (
                                                            <tr key={user.id || i}>
                                                                <td>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={selectedAmbassadors.includes(user.id)}
                                                                        onChange={() => handleToggleAmbassador(user.id)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <Avatar
                                                                        src={resolveFileUrl(user.avatar || defaultAvatarImg)}
                                                                        alt={user.name}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <ClickableText onClick={() => setSelectedUserId(user.id)}>
                                                                        {user.name || `${user.firstName || ''} ${user.lastName || ''}`}
                                                                    </ClickableText>
                                                                </td>
                                                                <td>{user.email}</td>
                                                                <td>
                                                                    {user.ambassadorType || 'Амбассадор'}
                                                                </td>
                                                                <td>{user.universityName || '-'}</td>
                                                                <td>
                                                                    {isExpired ? (
                                                                        <ExpiredBadge>Срок истек</ExpiredBadge>
                                                                    ) : (
                                                                        user.ambassadorExpirationTimestamp ?
                                                                            new Date(+user.ambassadorExpirationTimestamp).toLocaleDateString('ru-RU') :
                                                                            '-'
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </Table>
                                        </TableWrapper>
                                    </>
                                )}
                            </div>
                        )
                    },
                    {
                        label: "Посты амбассадоров",
                        content: (
                            <div>
                                <AdminPostsPanel />
                            </div>
                        )
                    },
                    {
                        label: "Статистика",
                        content: (
                            <div>

                                <AmbStatsPanel

                                />

                            </div>
                        )
                    }


                ]}
            />

            <Sidebar width={Math.min(820, window.innerWidth)} visible={addVisible} onCloserClick={() => {
                setAddVisible(false);
            }}>

                {addVisible == false ? null :
                    <div>
                        <AdminSearchAmbassadorTool
                            onAmbassadorAdded={async () => {
                                setLoading(true);
                                let arr = (await axios.get("/ambassadors/all")).data;
                                setUsers(arr);
                                setLoading(false);
                                setAddVisible(false);
                            }}
                        />
                    </div>
                }

            </Sidebar>

            <Sidebar width={Math.min(820, window.innerWidth)} visible={(selectedUser != undefined)}
                     onCloserClick={() => {
                         setSelectedUserId(undefined);
                     }}>

                {selectedUser == undefined ? null :
                    <div>

                        <div style={{ marginBottom: 20, textAlign: "center", fontSize: "12px" }}>
                            <a href={`/ambassadors/${selectedUser?.id}`} style={{ textDecoration: "underline" }}
                               target={"_blank"}>
                                перейти на страницу амбассадора
                            </a>
                        </div>

                        <Tabs
                            tabs={[
                                {
                                    label: "Реферальная программа",
                                    content: (
                                        <TabItem>
                                            <UserReferralsTool
                                                adminMode={true}
                                                user={selectedUser}
                                            />
                                        </TabItem>
                                    )
                                },
                                {
                                    label: "Настройки",
                                    content: (
                                        <TabItem>

                                            {/*<pre dangerouslySetInnerHTML={{ __html: JSON.stringify(selectedUser, null, 2) }}></pre>*/}

                                            {!(selectedUser?.userRole == "user") ? null :
                                                <div style={{ marginTop: 50 }}>
                                                    <Button onClick={async () => {
                                                        setLoading(true);
                                                        try {
                                                            let pld = (await axios.put(`/ambassadors`, {
                                                                id: selectedUser?.id,
                                                                isAmbassador: false
                                                            })).data;
                                                            let arr = (await axios.get("/ambassadors/all")).data;
                                                            setUsers(arr);
                                                            setSelectedUserId(undefined);
                                                        } catch (exc) {

                                                        }
                                                        setLoading(false);
                                                    }}>
                                                        Лишить статуса "Амбассадор"
                                                    </Button>

                                                    <div style={{ marginTop: 20, marginBottom: 20 }}>
                                                        <Label>
                                                            Статус амбассадора
                                                        </Label>
                                                        <div style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            alignItems: "center",
                                                            marginBottom: 20
                                                        }}>
                                                            <Select
                                                                options={AMB_TYPES_NEW}
                                                                value={AMB_TYPES_NEW.find(vv => vv.value == (selectedUser?.ambassadorType || "Амбассадор"))}
                                                                onChange={async dd => {
                                                                    setLoading(true);
                                                                    let isVip = (dd?.value == "Почетный Амбассадор");
                                                                    try {
                                                                        let pld = (await axios.put(`/ambassadors`, {
                                                                            id: selectedUser?.id,
                                                                            ambassadorType: dd?.value,
                                                                            isVip: isVip
                                                                        })).data;
                                                                        let arr = (await axios.get("/ambassadors/all")).data;
                                                                        setUsers(arr);
                                                                    } catch (exc) {

                                                                    }
                                                                    setLoading(false);
                                                                    toast.success("Сохранено");
                                                                }}
                                                            />
                                                            {/*{AMB_TYPES.map((a, i) => {*/}
                                                            {/*    return (*/}
                                                            {/*        <div key={i} style={{ marginRight: 20 }}*/}
                                                            {/*             onClick={async () => {*/}
                                                            {/*                 setLoading(true);*/}
                                                            {/*                 try {*/}
                                                            {/*                     let pld = (await axios.put(`/ambassadors`, {*/}
                                                            {/*                         id: selectedUser?.id,*/}
                                                            {/*                         isVip: a.value*/}
                                                            {/*                     })).data;*/}
                                                            {/*                     let arr = (await axios.get("/ambassadors/all")).data;*/}
                                                            {/*                     setUsers(arr);*/}
                                                            {/*                     setSelectedUserId(undefined);*/}
                                                            {/*                 } catch (exc) {*/}

                                                            {/*                 }*/}
                                                            {/*                 setLoading(false);*/}
                                                            {/*                 toast.success("Статус изменен");*/}
                                                            {/*             }}>*/}
                                                            {/*            <input type="checkbox"*/}
                                                            {/*                   checked={(selectedUser?.isVip == undefined ? false : selectedUser.isVip) == a.value}*/}

                                                            {/*            />*/}
                                                            {/*            <span style={{ marginLeft: 10 }}>*/}
                                                            {/*                {a.label}*/}
                                                            {/*            </span>*/}
                                                            {/*        </div>*/}
                                                            {/*    );*/}
                                                            {/*})}*/}
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <Control.Date label={"Срок действия статуса"} placeholder={""}
                                                                      value={selectedUser?.ambassadorExpirationTimestamp}
                                                                      onChange={async x => {
                                                                          // console.log('onChange: xxx = ', x);
                                                                          setLoading(true);
                                                                          try {
                                                                              let pld = (await axios.put(`/ambassadors`, {
                                                                                  id: selectedUser?.id,
                                                                                  ambassadorExpirationTimestamp: x?.target?.value
                                                                              })).data;
                                                                              let arr = (await axios.get("/ambassadors/all")).data;
                                                                              setUsers(arr);
                                                                          } catch (exc) {

                                                                          }
                                                                          setLoading(false);
                                                                          toast.success("Сохранено");
                                                                      }}
                                                        />
                                                    </div>

                                                    <div>
                                                        <div>
                                                            ВУЗ
                                                        </div>
                                                        <Select
                                                            placeholder={"Выберите ВУЗ"}
                                                            options={getAllUnisOptions(universities)}
                                                            value={getAllUnisOptions(universities).find(vv => (vv.value == selectedUser?.ambassadorUniversityId))}
                                                            onChange={async dd => {
                                                                setLoading(true);
                                                                try {
                                                                    let pld = (await axios.put(`/ambassadors`, {
                                                                        id: selectedUser?.id,
                                                                        ambassadorUniversityId: dd?.value,
                                                                        universityName: dd?.fullName || dd?.label
                                                                    })).data;
                                                                    let arr = (await axios.get("/ambassadors/all")).data;
                                                                    setUsers(arr);
                                                                } catch (exc) {

                                                                }
                                                                setLoading(false);
                                                                toast.success("Сохранено");
                                                            }}
                                                        />
                                                    </div>

                                                    <div style={{ marginTop: 10 }}>
                                                        <div>
                                                            Регион
                                                        </div>
                                                        <Select
                                                            placeholder={"Выберите регион"}
                                                            options={regionsOptions}
                                                            value={regionsOptions.find(vv => (vv.value == selectedUser?.ambassadorRegion))}
                                                            onChange={async dd => {
                                                                setLoading(true);
                                                                try {
                                                                    let pld = (await axios.put(`/ambassadors`, {
                                                                        id: selectedUser?.id,
                                                                        ambassadorRegion: dd?.value
                                                                    })).data;
                                                                    let arr = (await axios.get("/ambassadors/all")).data;
                                                                    setUsers(arr);
                                                                } catch (exc) {

                                                                }
                                                                setLoading(false);
                                                                toast.success("Сохранено");
                                                            }}
                                                        />
                                                    </div>

                                                    <div style={{ marginTop: 10 }}>
                                                        <div>
                                                            Город
                                                        </div>
                                                        <CityInput
                                                            type="text"
                                                            placeholder="Введите город"
                                                            value={selectedUser?.city || ''}
                                                            onChange={async (e) => {
                                                                const newCity = e.target.value;
                                                                // Обновляем локально сначала
                                                                setUsers(prev => prev.map(u =>
                                                                    u.id === selectedUser?.id
                                                                        ? { ...u, city: newCity }
                                                                        : u
                                                                ));
                                                            }}
                                                            onBlur={async (e) => {
                                                                const newCity = e.target.value;
                                                                setLoading(true);
                                                                try {
                                                                    await axios.put(`/ambassadors`, {
                                                                        id: selectedUser?.id,
                                                                        city: newCity
                                                                    });
                                                                    let arr = (await axios.get("/ambassadors/all")).data;
                                                                    setUsers(arr);
                                                                    toast.success("Город сохранен");
                                                                } catch (exc) {
                                                                    toast.error("Ошибка сохранения города");
                                                                }
                                                                setLoading(false);
                                                            }}
                                                        />
                                                    </div>

                                                    <div style={{ marginTop: 10 }}>
                                                        <div>
                                                            Email
                                                        </div>
                                                        <div>
                                                            {selectedUser?.email}
                                                        </div>
                                                    </div>


                                                </div>
                                            }

                                        </TabItem>
                                    )
                                },
                                {
                                    label: "Статистика",
                                    content: (
                                        <TabItem>
                                            <div>
                                                <AmbStatsPanel
                                                    id={selectedUser?.id}
                                                />
                                                {/*<StatsLi>*/}
                                                {/*    <LiLabel>*/}
                                                {/*        {`Количество пользователей, зарегистрированных на Платформе по реферальной ссылке: `}*/}
                                                {/*    </LiLabel>*/}
                                                {/*    <LiVal>*/}
                                                {/*        {3}*/}
                                                {/*    </LiVal>*/}

                                                {/*</StatsLi>*/}
                                                {/*<StatsLi>*/}
                                                {/*    <LiLabel>*/}
                                                {/*        {`Перечень мероприятий, в которых Амбассадор принял участие с использованием средств Платформы:`}*/}
                                                {/*    </LiLabel>*/}
                                                {/*    <div style={{ paddingLeft: 20 }}>*/}
                                                {/*        <li>*/}
                                                {/*            {`Мероприятие 1`}*/}
                                                {/*        </li>*/}
                                                {/*        <li>*/}
                                                {/*            {`Мероприятие 2`}*/}
                                                {/*        </li>*/}
                                                {/*    </div>*/}
                                                {/*</StatsLi>*/}
                                                {/*<StatsLi>*/}
                                                {/*    <LiLabel>*/}
                                                {/*        {`Количество исполненных бронирований путешественников, зарегистрированных по реферальной ссылке, в статусе «Исполнено: приехал»: `}*/}
                                                {/*    </LiLabel>*/}
                                                {/*    <LiVal>*/}
                                                {/*        {12}*/}
                                                {/*    </LiVal>*/}
                                                {/*</StatsLi>*/}
                                            </div>
                                        </TabItem>
                                    )
                                }

                            ]}
                        />

                    </div>
                }

            </Sidebar>

            {/* Модал продления срока */}
            <Sidebar
                width={Math.min(500, window.innerWidth)}
                visible={bulkExtendModalVisible}
                onCloserClick={() => setBulkExtendModalVisible(false)}
            >
                <ModalContent>
                    <h3>Продление срока действия статуса</h3>
                    <ConfirmText>
                        Вы собираетесь продлить срок действия статуса амбассадора для <strong>{selectedAmbassadors.length}</strong> пользователей.
                    </ConfirmText>

                    <FormSection>
                        <Label>Новый срок действия статуса</Label>
                        <Control.Date
                            placeholder="Выберите дату"
                            value={newExpirationDate}
                            onChange={(e) => setNewExpirationDate(e.target.value)}
                        />
                    </FormSection>

                    <ButtonGroup style={{ marginTop: 20 }}>
                        <Button onClick={() => setBulkExtendModalVisible(false)}>
                            Отмена
                        </Button>
                        <ConfirmButton onClick={handleBulkExtend}>
                            Подтвердить продление
                        </ConfirmButton>
                    </ButtonGroup>
                </ModalContent>
            </Sidebar>

            {/* Модал прекращения статуса */}
            <Sidebar
                width={Math.min(500, window.innerWidth)}
                visible={bulkRevokeModalVisible}
                onCloserClick={() => setBulkRevokeModalVisible(false)}
            >
                <ModalContent>
                    <h3>⚠️ Прекращение статуса амбассадора</h3>
                    <WarningText>
                        Вы уверены, что хотите прекратить статус амбассадора у <strong>{selectedAmbassadors.length}</strong> пользователей?
                    </WarningText>
                    <InfoText>
                        Это действие можно будет отменить, назначив статус заново.
                    </InfoText>

                    <ButtonGroup style={{ marginTop: 20 }}>
                        <Button onClick={() => setBulkRevokeModalVisible(false)}>
                            Отмена
                        </Button>
                        <DangerButton onClick={handleBulkRevoke}>
                            Подтвердить прекращение
                        </DangerButton>
                    </ButtonGroup>
                </ModalContent>
            </Sidebar>

            {/* Модал массового назначения */}
            <Sidebar
                width={Math.min(700, window.innerWidth)}
                visible={bulkAddModalVisible}
                onCloserClick={() => setBulkAddModalVisible(false)}
            >
                {bulkAddModalVisible && (
                    <BulkAddAmbassadorsModal
                        onClose={() => setBulkAddModalVisible(false)}
                        onSearch={handleBulkAdd}
                        onAssign={handleAssignAmbassadors}
                    />
                )}
            </Sidebar>

            {/* Модал изменения типа амбассадора */}
            <Sidebar
                width={Math.min(500, window.innerWidth)}
                visible={bulkChangeTypeModalVisible}
                onCloserClick={() => setBulkChangeTypeModalVisible(false)}
            >
                <ModalContent>
                    <h3>Изменение типа амбассадора</h3>
                    <ConfirmText>
                        Вы собираетесь изменить тип амбассадора для <strong>{selectedAmbassadors.length}</strong> пользователей.
                    </ConfirmText>

                    <FormSection>
                        <Label>Новый тип амбассадора</Label>
                        <Select
                            placeholder="Выберите тип"
                            options={AMB_TYPES_NEW}
                            value={AMB_TYPES_NEW.find(t => t.value === newAmbassadorType)}
                            onChange={(option) => setNewAmbassadorType(option.value)}
                        />
                    </FormSection>

                    <ButtonGroup style={{ marginTop: 20 }}>
                        <Button onClick={() => setBulkChangeTypeModalVisible(false)}>
                            Отмена
                        </Button>
                        <ConfirmButton onClick={handleBulkChangeType}>
                            Подтвердить изменение
                        </ConfirmButton>
                    </ButtonGroup>
                </ModalContent>
            </Sidebar>

        </Wrapper>
    );
}

const LiLabel = styled.div`
  opacity: 0.7;
  font-size: 14px;
`;

const LiVal = styled.div`
  font-weight: bold;
  font-size: 18px;
`;

const StatsLi = styled.div`
  padding: 10px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
`;

const Label = styled.div`
  font-weight: bold;
`;

const Wrapper = styled.div`

`;

const ListPlaceholder = styled.div`

`;

const TopPlaceholder = styled.div`
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;

const ViewToggleWrapper = styled.div`
  display: flex;
  gap: 5px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
`;

const ViewToggleButton = styled.button`
  padding: 8px 16px;
  border: none;
  background: ${({ active }) => (active ? '#02BF89' : 'white')};
  color: ${({ active }) => (active ? 'white' : '#333')};
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;

  &:hover {
    background: ${({ active }) => (active ? '#02BF89' : '#f5f5f5')};
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

const BulkActionsPanel = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
  background: #f4f9fc;
  border-radius: 4px;
  margin-bottom: 15px;
`;

const BulkActionsText = styled.div`
  font-weight: bold;
  margin-right: auto;
`;

const TableWrapper = styled.div`
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;

  th,
  td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }

  th {
    background: #f5f5f5;
    font-weight: bold;
  }

  tbody tr:hover {
    background: #f9f9f9;
  }
`;

const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
`;

const ClickableText = styled.div`
  color: #02bf89;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #019966;
  }
`;

const ExpiredBadge = styled.span`
  color: red;
  font-weight: bold;
`;

const ModalContent = styled.div`
  padding: 20px;
`;

const FormSection = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
`;

const WarningText = styled.p`
  color: #ef4058;
  font-size: 16px;
  line-height: 1.5;
  margin: 15px 0;
`;

const ConfirmText = styled.p`
  font-size: 16px;
  line-height: 1.5;
  margin: 15px 0;
  color: #333;
`;

const InfoText = styled.p`
  font-size: 14px;
  color: #666;
  margin: 10px 0;
  font-style: italic;
`;

const SearchSection = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
`;

const SearchInput = styled.input`
  flex: 1;
  padding: 10px 40px 10px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  font-family: "Noto Sans", sans-serif;

  &:focus {
    outline: none;
    border-color: #02bf89;
  }

  &::placeholder {
    color: #999;
  }
`;

const ClearButton = styled.button`
  position: absolute;
  right: 90px;
  background: none;
  border: none;
  font-size: 18px;
  color: #999;
  cursor: pointer;
  padding: 5px 10px;

  &:hover {
    color: #666;
  }
`;

const SearchResults = styled.div`
  font-size: 14px;
  color: #666;
  white-space: nowrap;
`;

const CheckboxWithTooltip = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;

  &::before {
    content: attr(title);
    position: absolute;
    left: calc(100% + 10px);
    top: 50%;
    transform: translateY(-50%);
    background: #333;
    color: white;
    padding: 8px 12px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s;
    z-index: 99999;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }

  &:hover::before {
    opacity: 1;
  }
`;

const ConfirmButton = styled(Button)`
  background: #02bf89;
  color: white;

  &:hover {
    background: #019966;
  }
`;

const DangerButton = styled(Button)`
  background: #ef4058;
  color: white;

  &:hover {
    background: #d63850;
  }
`;

// Компонент модала массового назначения
function BulkAddAmbassadorsModal({ onClose, onSearch, onAssign }) {
    const [emailsText, setEmailsText] = useState('');
    const [foundUsers, setFoundUsers] = useState([]);
    const [ambassadorType, setAmbassadorType] = useState('Амбассадор');
    const [expirationDate, setExpirationDate] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSearch = async () => {
        setLoading(true);
        const users = await onSearch(emailsText, ambassadorType, expirationDate);
        setFoundUsers(users || []);
        setLoading(false);
    };

    const handleAssign = async () => {
        if (!ambassadorType) {
            toast.error('Выберите статус амбассадора');
            return;
        }

        if (!expirationDate) {
            toast.error('Укажите срок действия статуса');
            return;
        }

        if (!window.confirm(`Назначить статус "${ambassadorType}" для ${foundUsers.length} путешественников?`)) {
            return;
        }

        await onAssign(
            foundUsers.map(u => u.id),
            ambassadorType,
            expirationDate
        );

        setEmailsText('');
        setFoundUsers([]);
        onClose();
    };

    return (
        <ModalContent>
            <h3>Массовое назначение амбассадоров</h3>

            <FormSection>
                <Label>
                    Введите email адреса путешественников
                    <br />
                    (по одному на строку или через запятую)
                </Label>
                <Textarea
                    rows={10}
                    placeholder="user1@example.com&#10;user2@example.com&#10;user3@example.com"
                    value={emailsText}
                    onChange={(e) => setEmailsText(e.target.value)}
                />
            </FormSection>

            <Button onClick={handleSearch} disabled={loading}>
                {loading ? 'Поиск...' : 'Найти пользователей'}
            </Button>

            {foundUsers.length > 0 && (
                <div style={{ marginTop: 20 }}>
                    <h4>Найдено пользователей: {foundUsers.length}</h4>

                    <UsersPreview>
                        {foundUsers.map((user, i) => (
                            <UserCard key={user.id || i}>
                                <div><strong>{user.name || `${user.firstName || ''} ${user.lastName || ''}`}</strong></div>
                                <div style={{ fontSize: '12px', color: '#666' }}>{user.email}</div>
                                {user.isAmbassador && (
                                    <div style={{ fontSize: '12px', color: '#F5C451' }}>Уже амбассадор</div>
                                )}
                            </UserCard>
                        ))}
                    </UsersPreview>

                    <FormSection>
                        <Label>Статус амбассадора</Label>
                        <Select
                            options={AMB_TYPES_NEW}
                            value={AMB_TYPES_NEW.find(t => t.value === ambassadorType)}
                            onChange={(option) => setAmbassadorType(option.value)}
                        />
                    </FormSection>

                    <FormSection>
                        <Label>Срок действия статуса</Label>
                        <Control.Date
                            placeholder="Выберите дату"
                            value={expirationDate}
                            onChange={(e) => setExpirationDate(e.target.value)}
                        />
                    </FormSection>

                    <ButtonGroup style={{ marginTop: 20 }}>
                        <Button onClick={onClose}>
                            Отмена
                        </Button>
                        <Button onClick={handleAssign} disabled={loading}>
                            Назначить статус
                        </Button>
                    </ButtonGroup>
                </div>
            )}
        </ModalContent>
    );
}

const Textarea = styled.textarea`
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #02bf89;
  }
`;

const UsersPreview = styled.div`
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const UserCard = styled.div`
  padding: 8px;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
`;

const CityInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  margin-top: 5px;

  &:focus {
    outline: none;
    border-color: #02bf89;
  }

  &::placeholder {
    color: #999;
  }
`;